class PrintCheckoutController {
    /*@ngInject*/
    constructor(Auth, $state, User, $translate, UsersService, ShipmentService, $location, $stateParams, RouteDetailService) {
        this.$translate = $translate
        this.UsersService = UsersService
        this.Auth = Auth
        this.$state = $state
        this.User = User
        this.ShipmentService = ShipmentService;
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.branchId = this.User.getUser().branchId;
        this.shipmentReportData = [];
        this.totalAmount = 0;
        this.totalCoin = 0;
        this.RouteDetailService = RouteDetailService;
        this.model = {
            itemList: []
        }
    }

    $onInit() {
        const branch = this.$stateParams.branchId;
        const route = this.$stateParams.scannedRouteId;
        const date = this.$stateParams.date;
        
        this.ShipmentService.getCheckoutManifestData(branch, route, date)
            .then((data) => {
                this.routeId = route;
                this.deliveryDate = date;
                this.shipmentReportData = data;
                this.model.itemList = data.itemList;
                if (this.shipmentReportData && this.shipmentReportData.results && this.shipmentReportData.results.length > 0) {
                    this.shipmentReportData.results = _.sortBy(this.shipmentReportData.results, ['fromLocationId', 'toLocationId'])
                    this.shipmentReportData.results[0].matchPreviousRow = false;
                    for (var i = 0; i < this.shipmentReportData.results.length; i++) {
                        var from = this.shipmentReportData.results[i].fromLocationId;
                        let to = this.shipmentReportData.results[i].toLocationId;
                        var rows = 1;
                        for (var j = i + 1; j < this.shipmentReportData.results.length; j++) {
                            if (this.shipmentReportData.results[j].fromLocationId === from && this.shipmentReportData.results[j].toLocationId === to && !this.shipmentReportData.results[j].matchPreviousRow) {
                                rows++;
                                this.shipmentReportData.results[j].matchPreviousRow = true;
                            } else {
                                break;
                            }
                        }
                        this.shipmentReportData.results[i].rows = rows;
                    }
                }
                this.userData = this.User.getUser();
                this.messengerDetails = data.messengerDetail;
                setTimeout(() => {
                    window.print()
                }, 1000)
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.loading = false;
            })
    }
}

export default PrintCheckoutController;


// WEBPACK FOOTER //
// ./client/app/components/checkout/print/print_checkout.controller.js